import SkeletonText from 'automation-ui-core/components/SkeletonText';
import ObjectTypeName from 'automation-ui-references/object-types/ObjectTypeName';
import { jsx as _jsx } from "react/jsx-runtime";
export function getObjectTypeNameMessageOptions({
  flowObjectTypeId,
  targetObjectTypeId
}) {
  // NOTE(bheng): Some languages such as Dutch require capitalized nouns.
  const enrolledObjectTypeOptions = {
    enrolledObjectType: /*#__PURE__*/_jsx(ObjectTypeName, {
      objectTypeId: flowObjectTypeId
    }),
    enrolledObjectTypeCapitalized: /*#__PURE__*/_jsx(ObjectTypeName, {
      isCapitalized: true,
      objectTypeId: flowObjectTypeId
    })
  };
  const targetObjectTypeOptions = targetObjectTypeId ? {
    targetObjectType: /*#__PURE__*/_jsx(ObjectTypeName, {
      objectTypeId: targetObjectTypeId
    }),
    targetObjectTypeCapitalized: /*#__PURE__*/_jsx(ObjectTypeName, {
      isCapitalized: true,
      objectTypeId: targetObjectTypeId
    }),
    targetObjectTypePlural: /*#__PURE__*/_jsx(ObjectTypeName, {
      isPlural: true,
      objectTypeId: targetObjectTypeId
    }),
    targetObjectTypePluralAndCapitalized: /*#__PURE__*/_jsx(ObjectTypeName, {
      isCapitalized: true,
      isPlural: true,
      objectTypeId: targetObjectTypeId
    })
  } : {
    targetObjectType: /*#__PURE__*/_jsx(SkeletonText, {}),
    targetObjectTypeCapitalized: /*#__PURE__*/_jsx(SkeletonText, {}),
    targetObjectTypePlural: /*#__PURE__*/_jsx(SkeletonText, {}),
    targetObjectTypePluralAndCapitalized: /*#__PURE__*/_jsx(SkeletonText, {})
  };
  return Object.assign({}, enrolledObjectTypeOptions, targetObjectTypeOptions);
}